"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaDetailHeader = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));

var _string = require("../../../util/string");

var _alloyReactHelpers = require("@adsk/alloy-react-helpers");

var _mediaDetailContext = require("../media-detail-context");

var _Spacer = _interopRequireDefault(require("../../shared/Spacer"));

var _qa = _interopRequireDefault(require("../../../util/qa"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const SubjectLine = _styledComponents.default.div`
  font-size: ${_alloyReactTheme.default.typography.bodySmall.fontSize};
  color: ${_alloyReactTheme.default.colors.charcoal700};
`;
const InfoLine = _styledComponents.default.div`
  font-size: ${_alloyReactTheme.default.typography.bodyMediumBold.fontSize};
  color: ${_alloyReactTheme.default.colors.charcoal900};
`;
const SubText = _styledComponents.default.div`
  color: ${_alloyReactTheme.default.colors.charcoal700};
`;

const MediaDetailHeader = () => {
  var _media$takenBy, _media$takenBy2, _media$takenBy3;

  const {
    state: {
      media
    }
  } = (0, _mediaDetailContext.useMedia)();
  const {
    T
  } = (0, _alloyReactHelpers.useLocale)(({
    locale
  }) => require(`../../i18n/${locale}.json`));
  const content = [{
    subject: T.translate("TAKEN_BY"),
    lineContent: `${((_media$takenBy = media.takenBy) === null || _media$takenBy === void 0 ? void 0 : _media$takenBy.firstName) || ""} ${((_media$takenBy2 = media.takenBy) === null || _media$takenBy2 === void 0 ? void 0 : _media$takenBy2.lastName) || ""} ${((_media$takenBy3 = media.takenBy) === null || _media$takenBy3 === void 0 ? void 0 : _media$takenBy3.status) === "deleted" ? ` ${T.translate("REMOVED")}` : ""}`
  }, {
    subject: T.translate("TAKEN_ON"),
    lineContent: media.takenOn ? (0, _string.getFormattedDate)(media.takenOn) : /*#__PURE__*/_react.default.createElement(SubText, null, T.translate("DATA_NOT_AVAILABLE"))
  }, {
    subject: T.translate("ADDED_ON"),
    lineContent: (0, _string.getFormattedDate)(media.createdAt)
  }];

  if (!media.takenBy) {
    content.shift();
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    "data-qa": _qa.default.mediaDetailDetailsHeader
  }, content.map((sectionContent, i) => /*#__PURE__*/_react.default.createElement("div", {
    key: String(sectionContent.subject) + i
  }, /*#__PURE__*/_react.default.createElement(SubjectLine, null, sectionContent.subject), /*#__PURE__*/_react.default.createElement(_Spacer.default, {
    height: 8
  }), /*#__PURE__*/_react.default.createElement(InfoLine, null, sectionContent.lineContent), /*#__PURE__*/_react.default.createElement(_Spacer.default, {
    height: 12
  }))), /*#__PURE__*/_react.default.createElement(_Spacer.default, {
    height: 12
  }));
};

exports.MediaDetailHeader = MediaDetailHeader;